import {
  Button,
  Filters,
  Header,
  Search,
  Select,
  StickyFooterButtons,
  useLoading,
  ValueOpt,
  useBreakpoints,
} from "best-common-react";
import React, { useCallback, useEffect, useState } from "react";
import { getRequestsByGamePk } from "../../../api/RequesTixApi";
import AdminRequestGame from "../../../components/requests/admin/AdminRequestGame";
import RouteConstants from "../../../constants/RouteConstants";
import { useDropdowns } from "../../../contexts/DropdownsContext";
import { ReportComplete, RequestCategory, RequestState } from "../../../types/RequestType";
import { getCategoryOption, getCompleteOption, getStatusOption } from "../../../util/DropdownUtil";
import { useUrlParams } from "../../../util/RouteUtil";
import { requestsFreeTextSearch } from "../../../util/TicketRequestUtil";
import { useLocation, useNavigate, useParams } from "react-router";
import { AdminRequestsDTO } from "../../../types/AdminRequest";
import { TicketRequest } from "../../../types/TicketRequest";

const AdminRequestByGame = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setLoading } = useLoading();
  const { isMobile } = useBreakpoints();
  const { gamePk } = useParams();
  const [data, setData] = useState({
    game: null,
    requests: [],
    totalRequests: 0,
  });
  const [filteredData, setFilteredData] = useState<TicketRequest[]>([]);

  const { requestCategoryOptions, requestStateOptions, completeOptions } = useDropdowns();

  const [{ statusId, categoryId, completeId, search }, setParam] = useUrlParams({
    statusId: undefined,
    categoryId: undefined,
    completeId: undefined,
    search: undefined,
  });

  const category = getCategoryOption(categoryId ?? "", requestCategoryOptions);
  const status = getStatusOption(statusId ?? "", requestStateOptions);
  const complete = getCompleteOption(completeId ?? "", completeOptions);

  const close = useCallback(() => {
    if (location.state?.previousLocation) {
      navigate(location.state.previousLocation);
    } else {
      navigate(RouteConstants.ADMIN.REQUESTS);
    }
  }, [location, navigate]);

  const fetchGames = useCallback(async () => {
    try {
      setLoading(true);
      //@ts-ignore
      const resp: AdminRequestsDTO = await getRequestsByGamePk(gamePk!, statusId ?? [], categoryId, completeId);
      setData({
        game: resp.games[gamePk!],
        requests: resp.requests[gamePk!],
        totalRequests: resp.totalRequests[gamePk!],
      });
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [gamePk, statusId, categoryId, completeId, setLoading]);

  useEffect(() => {
    void fetchGames();
  }, [fetchGames]);

  useEffect(() => {
    setFilteredData(requestsFreeTextSearch(data.requests, search ?? ""));
  }, [data, search]);

  return (
    <div>
      <Header title="Ticket Requests" flexColumn>
        <Filters actionIconPosition="absolute" numberDisplayed={isMobile ? 1 : 4}>
          <Select
            id="status"
            label="Status"
            value={status}
            options={requestStateOptions}
            onChange={(value: ValueOpt<RequestState>) => setParam("statusId", String(value.value.requestStateId))}
            placeholder="select a status"
            gutterBottom
          />
          <Select
            id="complete"
            label="Complete/Incomplete"
            value={complete}
            options={completeOptions}
            onChange={(value: ValueOpt<ReportComplete>) => setParam("completeId", String(value.value.id))}
            placeholder="select a complete status"
            gutterBottom
          />
          <Select
            id="category"
            label="Category"
            value={category}
            options={requestCategoryOptions}
            onChange={(value: ValueOpt<RequestCategory>) =>
              setParam("categoryId", String(value.value.requestCategoryId))
            }
            placeholder="select a category"
            gutterBottom
          />
          <Search
            id="search"
            label="Search Requests"
            value={search}
            onChange={(value: string) => setParam("search", value || undefined)}
            placeholder="begin typing to filter requests"
            gutterBottom
          />
        </Filters>
      </Header>
      <div className="bcr-p-2">
        {/* @ts-ignore */}
        <div>{data.game && <AdminRequestGame {...data} requests={filteredData} showHeader={true} />}</div>

        <StickyFooterButtons startsOpen={true}>
          <Button variant="default" onClick={close}>
            Close
          </Button>
        </StickyFooterButtons>
      </div>
    </div>
  );
};

export default AdminRequestByGame;
